/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import SideNavigationView from './side-navigation/SideNavigation.view';
import { Box } from '@mui/material';
import { TopNavigationView } from './top-navigation/TopNavigation.view';

interface Props {
	title: string;
	shouldRenderUserMenu: boolean;
	shouldRenderFlaggedContentMenu: boolean;
	shouldRenderGroupMenu: boolean;
	shouldRenderConfigurationMenu: boolean;
	shouldRenderExternalContributionsMenu: boolean;
	shouldRenderStatisticsMenu: boolean;
}

class NavigationView extends React.Component<React.PropsWithChildren<Props>> {
	render(): JSX.Element {
		const {
			title,
			children,
			shouldRenderUserMenu,
			shouldRenderFlaggedContentMenu,
			shouldRenderGroupMenu,
			shouldRenderConfigurationMenu,
			shouldRenderExternalContributionsMenu,
			shouldRenderStatisticsMenu
		} = this.props;
		return (
			<React.Fragment>
				<TopNavigationView title={title} />
				<Box display="flex" flexDirection="row">
					<SideNavigationView
						shouldRenderUserMenu={shouldRenderUserMenu}
						shouldRenderFlaggedContentMenu={shouldRenderFlaggedContentMenu}
						shouldRenderGroupMenu={shouldRenderGroupMenu}
						shouldRenderConfigurationMenu={shouldRenderConfigurationMenu}
						shouldRenderExternalContributionsMenu={shouldRenderExternalContributionsMenu}
						shouldRenderStatisticsMenu={shouldRenderStatisticsMenu}
					/>
					<Box component="main" sx={{ marginTop: 8, padding: 2, flexGrow: 1, minWidth: 0 }}>
						{children}
					</Box>
				</Box>
			</React.Fragment>
		);
	}
}

export default NavigationView;
